const life = [
    {
        alias: "backintimefordinner",
        navigation: [
            {
                link: "/life/backintimefordinner",
                title: "Latest",
                type: "internal",
            },
            {
                link: "/life/backintimefordinner/episodes",
                title: "Episodes",
                type: "internal",
            },
        ],
    },
    {
        alias: "jamieoliver",
        navigation: [
            {
                link: "/life/jamieoliver",
                title: "Home",
                type: "internal",
            },
            {
                link: "/life/jamieoliver/recipes",
                title: "Recipes",
                type: "internal",
            },
            {
                link: "/life/jamieoliver/watch",
                title: "Watch",
                type: "internal",
            },
        ],
    },
];

export default life;
